import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TPickerWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";
import { EventType } from "../../../constants/AppsmithActionConstants/ActionConstants";

// 定义常量：时间单位配置（包含粒度层级）
export const TIME_UNITS:any = {
  year: { label: '年', range: (current: number) => [current - 50, current + 50], level: 1, format: 'YYYY' },
  month: { label: '月', range: [1, 12], level: 2, format: 'YYYY-MM' },
  day: { label: '日', range: [1, 31], level: 3, format: 'YYYY-MM-DD' },
  hour: { label: '时', range: [0, 23], level: 4, format: 'YYYY-MM-DD HH' },
  minutes: { label: '分', range: [0, 59], level: 5, format: 'YYYY-MM-DD HH:mm' },
  seconds: { label: '秒', range: [0, 59], level: 6, format: 'YYYY-MM-DD HH:mm:ss' },
} as const


class TPicker extends TaroWidget<TPickerWidgetProps, WidgetState> {
  constructor(props: TPickerWidgetProps) {
    super(props);
  }

  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("AtPickerWidget");
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }
  static getDefaultPropertiesMap(): Record<string, string> {
    return {
      value: "defaultOptionValue"
    };
  }

  static getPropertyPaneContentConfig  = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`,
      isValid: `{{ this.isRequired ? !!this.value : true }}`
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
      inputFontSize: "{{appsmith.theme.form.inputText.fontSize}}",
      inputColor: "{{appsmith.theme.form.inputText.fontColor}}",
      inputFontStyle: "{{appsmith.theme.form.inputText.fontStyle}}",
      bgColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
      borderColor: "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
    };
  }
  updateWidgetProperty = (propertyValues: string) => {
    if(propertyValues != this.props.value){
      this.onOptionChange();
      this.props.updateWidgetMetaProperty("value", propertyValues);
    }
  }

  onOptionChange = ()=>{
    if(this.props.onOptionChange){
      super.executeAction({
        triggerPropertyName: "onOptionChange",
        dynamicString: this.props.onOptionChange,
        event: {
          type: EventType.ON_OPTION_CHANGE,
        }
      })
    }
  }

  getPageView() {
    let initValue = this.props.value;
    return (
      <TPickerWidget {...this.props} value={initValue} updateWidgetProperty={this.updateWidgetProperty} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_PICKER_WIDGET";
  }
}

export interface TPickerWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TPicker;
